import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function ContnetBackgroundImage({ image })
{
  return (
    <div className="relative h-64 z-0">
      <GatsbyImage
        image={getImage(image)}
        alt="TODO"
        className=" absolute w-full h-80 overflow-y-hidden"
      />
    </div>
  )
}

export default ContnetBackgroundImage;